module.exports = __webpack_public_path__ + "img/img-nor.6361be42.svg";